export const responseMultipleChoicesQueryKeys = {
  all: ['responseMultipleChoices'] as const,
}
